import { MenuItem, Theme } from '@mui/material';
import { FormikTextField } from '../../../common/formik-material-ui';
import { RecordNow } from '../recorder/RecordNow';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    color: 'var(--primary)', // pull color from primary
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: 10,
  },
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
  modal: {
    paddingBottom: 0,
    maxHeight: 'calc(100vh - 210px)',
    overflowY: 'auto',
  },
  defaultAction: {
    marginTop: theme.spacing(2),
  },
}));

export const AddVMDropModalTab = ({
  formik,
  uploadedFiles,
  filenames,
  filepaths,
  setUploadedFiles,
  setFilenames,
  setFilepaths,
  setVmDropRecording,
}) => {
  const classes = useStyles();

  const onChangeFile = (type) => ({ target: { files } }) => {
    setFilenames({
      ...filenames,
      // voicemail or greeting
      [type]:
        files.length > 1 ? `${files.length} files` : files?.[0]?.name ?? '',
    });
    setFilepaths({
      ...filepaths,
      [type]: files?.[0] && URL.createObjectURL(files?.[0]), // create file blob
    });
    setUploadedFiles({
      ...uploadedFiles,
      [type]: files,
    }); // take first file
  };

  const handleRecording = (type) => (files) => {
    setUploadedFiles({
      ...uploadedFiles,
      [type]: files,
    });
  };

  return (
    <main className="col">
      <div>
        <FormikTextField
          name="VMDrop.VMDropName"
          className={classes.field}
          formik={formik}
          fullWidth
          label="Name"
          size="small"
          required
          variant="outlined"
        />
      </div>
      <div>
        <RecordNow
          dropdownLabel="Voice Mail Message"
          dropdownName="VMDrop.mp3Type"
          dropdownType={formik.values?.VMDrop.mp3Type}
          outlineLabel="Voice Mail Message"
          ttsLabel="Voicemail"
          filenameName="VMDrop.mp3File"
          filesizeName="VMDrop.mp3Name"
          formik={formik}
          filename={filenames.voicemail}
          filepath={filepaths.voicemail}
          onChangeFile={onChangeFile('voicemail')}
          onRecording={handleRecording('voicemail')}
          setVmDropRecording={setVmDropRecording}
        >
          <MenuItem value="mp3">MP3</MenuItem>
          <MenuItem value="record">Record Now</MenuItem>
        </RecordNow>
      </div>
    </main>
  );
};
